import React, { useEffect } from 'react';
import { t } from '../../../../shared/components/l10n/l10n';
import { Button, Modal, Badge, Spinner } from '@economic/gaudi';
import useQuery from '../../../../shared/hooks/useQuery';

interface Props {
    onCancel: () => void;
    onDone: () => void;
}

export default function StepValidate({ onCancel, onDone }: Props) {
    const { loading: validationLoading, data: validationErrors, error } = useQuery<string[]>(
        '/moneyflow/company/getOnboardingValidationErrors'
    );

    const validationSucceeded = !validationLoading && (!validationErrors || validationErrors.length === 0);

    useEffect(() => {
        if (validationSucceeded) {
            onDone();
        }
    }, [validationSucceeded]);

    if (validationLoading) {
        return <Spinner />;
    }

    if (error) {
        return <div className="moneyflow__onboarding moneyflow__onboarding__validation_error">{error.toString()}</div>;
    }

    if (validationSucceeded) {
        return <></>;
    }

    return (
        <>
            <Modal.Content>
                <div className="moneyflow__onboarding moneyflow__onboarding__validation_error">
                    <h1>
                        <Badge className="py-4 px-3 text-2xl">!</Badge>
                    </h1>
                    <h2>{t`MONEYFLOW_ONBOARDING_ERROR_VALIDATION_HEADER`}</h2>
                    <div className="ml-5">
                        {validationErrors.map(error => (
                            <p>
                                <Badge className="p-2 mr-1">!</Badge> {error}
                            </p>
                        ))}
                    </div>
                </div>
            </Modal.Content>
            <Modal.Footer>
                <Button appearance="primary" onClick={() => onCancel()}>
                    {t`MONEYFLOW_ONBOARDING_ERROR_VALIDATION_CLOSE_BUTTON`}
                </Button>
            </Modal.Footer>
        </>
    );
}
